module.exports = __webpack_public_path__ + "img/logo3mix-1.94d41563.webp";